import React, { useState } from 'react';
import { FaTimes, FaPlus, FaMinus, FaTrashAlt, FaHeart } from 'react-icons/fa';
import { getImagePath } from '../constants/defaultValues';
import { useThemeColors } from '../hooks/useThemeColors';
import FavoriteButton from './common/FavouriteButton';

const ProductModal = ({ product, onClose, onAddToCart, darkMode }) => {
  const [quantity, setQuantity] = useState(1);
  const { textColor, subTextColor, contentBg } = useThemeColors(darkMode);


  const calculateTotal = () => (product.shopPrice * quantity);

  const handleAddToCart = () => {
    const itemToAdd = {
      ...product,
      id: product.id,
      quantity: quantity,
      shopPrice: product.shopPrice,
      title: product.name || product.title
    };
    onAddToCart(itemToAdd);
    onClose();
  };


  console.log('product detail', product)
  if (!product) return null;

  return (
    <div className="custom-modal-overlay d-flex align-items-center justify-content-center p-2">
      <div
        className="product-card-modal position-relative border-0 shadow-lg overflow-hidden mx-auto"
        style={{
          backgroundColor: contentBg,
          maxWidth: '500px',
          width: '100%',
          borderRadius: '24px',
          animation: 'slideUp 0.3s ease-out',
          maxHeight: '95vh',
          overflowY: 'auto'
        }}
      >
        <FavoriteButton 
            productId={product.id} 
            darkMode={darkMode} 
        />

        {/* Close Button */}
        <button
          className="btn btn-dark position-absolute top-0 end-0 m-3 shadow-sm rounded-circle d-flex align-items-center justify-content-center"
          onClick={onClose}
          style={{
            zIndex: 10,
            width: '32px',
            height: '32px',
            opacity: '0.9',
            border: 'none'
          }}
        >
          <FaTimes size={14} />
        </button>

        <div className="row g-0">
          <div className="col-12">
            <div
              className="overflow-hidden"
              style={{
                backgroundColor: '#f8f9fa'
              }}
            >
              <img
                src={product?.image?.fileToken ? `${getImagePath}${product.image.fileToken}` : ''}
                alt={product.name}
                className="w-100 h-100 card-img-effect"
                style={{
                  objectFit: 'cover',
                  minHeight: '180px',
                  maxHeight: '240px'
                }}
              />
            </div>
          </div>

          <div className="col-12 p-3 p-sm-4">
            <div className="mb-3">
              <h2 className="fw-bold mb-2 fs-5 fs-md-4" style={{ color: textColor }}>
                {product.name}
              </h2>
              <p
                className="opacity-75"
                style={{
                  color: subTextColor,
                  fontSize: '0.85rem',
                  lineHeight: '1.4',
                  maxHeight: '60px',
                  overflowY: 'auto'
                }}
              >
                {product.shopDescription}
              </p>
            </div>

            <div className="mt-auto">
              <div
                className="d-flex align-items-center justify-content-between mb-3 p-2 px-3 shadow-sm"
                style={{
                  backgroundColor: darkMode ? '#2c2c2c' : '#f8f9fa',
                  borderRadius: '14px',
                  border: darkMode ? '1px solid #444' : '1px solid #eee'
                }}
              >
                <span className="fw-bold small text-muted" style={{ letterSpacing: '0.5px', fontSize: '10px' }}>QUANTITY</span>
                <div className="d-flex align-items-center gap-3">
                  <button
                    className="btn btn-link p-0 text-decoration-none"
                    style={{ color: '#e31837' }}
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  >
                    {quantity === 1 ? <FaTrashAlt size={14} /> : <FaMinus size={16} />}
                  </button>
                  <span className="fw-bold fs-6 px-2" style={{ color: textColor, minWidth: '20px', textAlign: 'center' }}>
                    {quantity}
                  </span>
                  <button
                    className="btn btn-link p-0 text-decoration-none text-success"
                    onClick={() => setQuantity(quantity + 1)}
                  >
                    <FaPlus size={16} />
                  </button>
                </div>
              </div>

              {/* Add to Cart Button */}
              <button
                className="btn btn-danger fs-6 btn-lg w-100 py-2 py-sm-3 fw-bold shadow-sm"
                style={{
                  borderRadius: '16px',
                  backgroundColor: '#e31837',
                  border: 'none',
                }}
                onClick={handleAddToCart}
              >
                ADD TO CART — Rs {calculateTotal().toLocaleString()}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;